var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { wMBold, primaryHeadingColor, secondaryFont } from '../../../Utils/utilsStyle';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: calc(100vh - 250px);\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  h3 {\n    font-size: 22px;\n    font-family: ", ";\n    font-weight: ", ";\n    color: ", ";\n  }\n"], ["\n  height: calc(100vh - 250px);\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  h3 {\n    font-size: 22px;\n    font-family: ", ";\n    font-weight: ", ";\n    color: ", ";\n  }\n"])), secondaryFont, wMBold, primaryHeadingColor);
var defaultProps = {
    title: '',
};
var NoDataFound = function NoDataFound(props) {
    var title = props.title;
    return (_jsx(Wrapper, __assign({ className: "no_data_found" }, { children: _jsx("h3", { children: title }) })));
};
NoDataFound.defaultProps = defaultProps;
export default NoDataFound;
var templateObject_1;
